import React, { createRef, Component } from "react";
import { Row, Col } from "antd";
import moment from "moment";
import profile from "../../../../assets/icons/profile-3.svg";
import Aggregator from "../../../../assets/icons/aggregator_leaf.svg";
import TooltipComponent from "../../../../CommonComponents/Info/Tooltip/TooltipComponent";
import WebView from "../../Components/DesignatedAccess/WebView";
import AddLinkToPill from "../../../../CommonComponents/EditLinkToPill/AddLinkToPill";
import SuccessionComponent from "../../Components/SuccessionComponent/SuccessionComponent";
import KnowAccessLevel from "../../Components/PopUp/KnowAccessLevel";

import { 
  FixedWidth,
  PagesHeading,
  DataHeading,
  DataValue,
  DisplayFlex,
  AlignItemsCenter,
  PrimaryIndicator,
  SectionLastHeading,
  BlurContainer,
  BlurOverlay,
  SectionDivider,
  JustifyBetween,
} from "../../../../CommonComponents/commonStyles";
import { milliToDate } from "../../../../utils/commonUtil";
import { PersonnelHeading, ItemHeading, ItemData, JustifyBetweenAccessLevel, InlineDiv } from "../../styles";
import { ContentMessage, Types } from "../../../../CommonComponents/ContentMessages";
import { isNewAdvent, sortAggrDates } from "../../utils";

class MyAccount extends Component {
  constructor(props) {
    super(props);
    this.state = {
      newFund: "",
      newPrimary: ""
    };
  }
  CountryCodeMappingData = data => {
    let countryName;
    if(this.props.countryCodeMappingData){
      this.props.countryCodeMappingData.forEach(item => {
        if (item.value === data) {
          countryName = item.desc;
        }
      });
    }
    return countryName;
  };
  componentDidMount() {
    window.scrollTo(0,0);
  }

  render() {
    const ref = createRef();    
    const {
      accData,
      newFund,
      newPrimary      
    } = this.props;
    let vanguardAccts = [];
    if (
      accData.authorization &&
      accData.authorization.vanguardAccounts &&
      accData.authorization.vanguardAccounts.length > 0
    ) {
      vanguardAccts = accData.authorization.vanguardAccounts.filter((a, i) => {
        let receivedDate = moment(new Date(a.receivedDate)).format(
          "MM/DD/YYYY"
        );
        let diffYears = moment().diff(receivedDate, "years", true);

        return (
          (a.accountRegistration === "Private Foundation" ||
            a.accountRegistration === "Other") &&
          diffYears <= 5
        );
      });
    }
    return (
      <>
        <FixedWidth data-test="myAccountPrintBlock">
          <BlurContainer ref={ref}>
            <AlignItemsCenter>
              <PagesHeading>
                The {newFund} Fund ({accData.fundNumber})
              </PagesHeading>
              <div className="ml-10">
              </div>
            </AlignItemsCenter>
          </BlurContainer>

          <JustifyBetween>
            <AlignItemsCenter className="mt2">
              <DataHeading>Primary Account Contact:</DataHeading>
              <DataValue className="mt0">
                {newPrimary}
                <TooltipComponent text="yet to decide" />
              </DataValue>
              <div className="ml2">
              </div>
            </AlignItemsCenter>
          </JustifyBetween>

          <DisplayFlex className="mt1">
            <DataHeading>Date Opened: </DataHeading>
            <DataValue className="mt0 ml-05">
              {moment(moment.tz(accData.dateOpened, "America/New_York")).format(
                "L"
              )}
            </DataValue>
          </DisplayFlex>

          {/****************************** ADVISOR **************************************/}
          <BlurContainer ref={ref}>
            <BlurOverlay isEnabled={!this.state.accAdvisorBlur} />
            <AlignItemsCenter className="mt-50 mb-40">
              <SectionLastHeading className="mb0">
              <ContentMessage type={[Types.SUB_HEADING_LEGACY_OPTIONS]} page="My Account" property="field_type_1_title" defaultMessage="Account Advisors" />
              </SectionLastHeading>
            </AlignItemsCenter>
            <Row>
              {accData.accountAdvisors.map((item, index) =>
                accData.accountAdvisors.length > 1 ? (
                  <Col lg={8} md={8} xs={24} key ={index}>
                    <Row>
                      <Col lg={2} md={2} xs={2}>
                        <img src={profile} alt="Profile"/>
                      </Col>
                      <Col lg={22} md={22} xs={22}>
                        <AlignItemsCenter className="mb1">
                          <PersonnelHeading>
                            {index < 1 ? "Primary" : "Secondary"} Advisor
                          </PersonnelHeading>
                          {item.primaryAccountContact ? (
                            <PrimaryIndicator className="ml-10 mt-03">
                              Primary
                            </PrimaryIndicator>
                          ) : (
                            ""
                          )}
                        </AlignItemsCenter>
                        <ItemData className="mt0">{item.name}</ItemData>
                        <DisplayFlex className="mt-05">
                          <ItemHeading>DOB </ItemHeading>
                          <ItemData className="mt0 ml-05">
                          {item.dob === null || item.dob === "" ? (
                              <> &mdash; </>
                            ) : (
                              milliToDate(item.dob)
                            )}
                          </ItemData>
                        </DisplayFlex>
                        <DisplayFlex className="mt-05">
                          <ItemHeading>Email </ItemHeading>
                          <ItemData className="mt0 ml-05">
                            {item.email}
                          </ItemData>
                        </DisplayFlex>
                        <DisplayFlex className="mt-05">
                          <ItemHeading>Phone </ItemHeading>
                          <ItemData className="mt0 ml-05">
                            {item.phone}
                          </ItemData>
                        </DisplayFlex>
                        <DisplayFlex className="mt-05">
                          <ItemHeading>Address </ItemHeading>
                          <div>
                            <ItemData className="mt0 ml-05">
                              {item.address.address?item.address.address+",":''}
                            </ItemData>
                            <ItemData className="mt0 ml-05">
                              {item.address.addressLine1?item.address.addressLine1+",":''}
                            </ItemData>
                            <ItemData className="mt0 ml-05">
                              {item.address.addressLine2?item.address.addressLine2+",":''}
                            </ItemData>
                            <ItemData className="mt0 ml-05">
                              {item.address.addressLine3?item.address.addressLine3+",":''}
                            </ItemData>
                            <ItemData className="mt0 ml-05">
                              {item.address.city}, {item.address.state}, 
                              {item.address.zipCode}
                            </ItemData>
                            <ItemData className="mt0 ml-05">
                              {this.CountryCodeMappingData(
                                item.address.country 
                              )}
                            </ItemData>
                          </div>
                        </DisplayFlex>
                        {item.dataAggregators && item.dataAggregators.length ?
                          (<DisplayFlex className="mt-05">
                            <ItemHeading>Data Aggregator </ItemHeading>
                            <ItemData className="mt0 ml-05">
                              {sortAggrDates(item.dataAggregators).map((agg, cnt) => {
                                if (item.dataAggregators.length - 1 === cnt) return agg.aggrName;
                                else return agg.aggrName + ', ';
                              })}
                              {isNewAdvent(item.dataAggregators) ? (
                                <InlineDiv>
                                  <img src={Aggregator} className="aggregator_iconleaf" alt="aggregator" />
                                  <span className="aggregator_newbtn">New</span></InlineDiv>
                              ) : <></>}
                            </ItemData>
                          </DisplayFlex>) : <></>}
                        <DisplayFlex className="mt-05">
                          <ItemHeading>Delivery Method </ItemHeading>
                          <ItemData className="mt0 ml-05">
                            {item.deliveryMethod}
                          </ItemData>
                        </DisplayFlex>
                      </Col>
                    </Row>
                  </Col>
                ) : (
                  <>
                    <Col lg={8} md={8} xs={24}>
                      <Row>
                        <Col lg={2} md={2} xs={2}>
                          <img src={profile} alt="Profile"/>
                        </Col>
                        <Col lg={22} md={22} xs={22}>
                          <AlignItemsCenter className="mb1">
                            <PersonnelHeading>Primary Advisor</PersonnelHeading>
                            {item.primaryAccountContact ? (
                              <PrimaryIndicator className="ml-10 mt-03">
                                Primary
                              </PrimaryIndicator>
                            ) : (
                              ""
                            )}
                          </AlignItemsCenter>
                          <ItemData className="mt0">{item.name}</ItemData>
                          <DisplayFlex className="mt-05 ml-05">
                            <ItemHeading>DOB </ItemHeading>
                            <ItemData className="mt0">
                            {item.dob === null || item.dob === "" ? (
                              <> &mdash; </>
                            ) : (
                              milliToDate(item.dob)
                            )}
                            </ItemData>
                          </DisplayFlex>
                          <DisplayFlex className="mt-05 ml-05">
                            <ItemHeading>Email </ItemHeading>
                            <ItemData className="mt0">{item.email}</ItemData>
                          </DisplayFlex>
                          <DisplayFlex className="mt-05 ml-05">
                            <ItemHeading>Phone </ItemHeading>
                            <ItemData className="mt0">{item.phone}</ItemData>
                          </DisplayFlex>
                          <DisplayFlex className="mt-05 ">
                            <ItemHeading>Address </ItemHeading>
                            <div>
                              <ItemData className="mt0 ml-05">
                              {item.address.address?item.address.address+",":''}
                            </ItemData>
                            <ItemData className="mt0 ml-05">
                              {item.address.addressLine1?item.address.addressLine1+",":''}
                            </ItemData>
                            <ItemData className="mt0 ml-05">
                              {item.address.addressLine2?item.address.addressLine2+",":''}
                            </ItemData>
                            <ItemData className="mt0 ml-05">
                              {item.address.addressLine3?item.address.addressLine3+",":''}
                            </ItemData>
                              <ItemData className="mt0 ml-05">
                              {item.address.city}, {item.address.state+" "} 
                              {item.address.zipCode+","}
                            </ItemData>
                            <ItemData className="mt0 ml-05">
                              {this.CountryCodeMappingData(
                                item.address.country 
                              )}
                            </ItemData>
                            </div>
                          </DisplayFlex>
                            {item.dataAggregators && item.dataAggregators.length ?
                              (<DisplayFlex className="mt-05">
                                <ItemHeading>Data Aggregator </ItemHeading>
                                <ItemData className="mt0 ml-05">
                                  {sortAggrDates(item.dataAggregators).map((agg, cnt) => {
                                    if (item.dataAggregators.length - 1 === cnt) return agg.aggrName;
                                    else return agg.aggrName + ', ';
                                  })}
                                  {isNewAdvent(item.dataAggregators) ? (
                                    <InlineDiv>
                                      <img src={Aggregator} className="aggregator_iconleaf" alt="aggregator" />
                                      <span className="aggregator_newbtn">New</span></InlineDiv>
                                  ) : <></>}
                                </ItemData>
                              </DisplayFlex>) : <></>}
                          <DisplayFlex className="mt-05">
                            <ItemHeading>Delivery Method </ItemHeading>
                            <ItemData className="mt0 ml-05">
                              {item.deliveryMethod}
                            </ItemData>
                          </DisplayFlex>
                        </Col>
                      </Row>
                    </Col>
                    <Col lg={8} md={8} xs={24}>
                      <Row>
                        <Col lg={2} md={2} xs={2}>
                          <img src={profile} alt="Profile"/>
                        </Col>
                        <Col lg={22} md={22} xs={22}>
                          <PersonnelHeading className="mb1">
                            Secondary Advisor
                          </PersonnelHeading>
                          <ItemHeading>No Records Found</ItemHeading>
                          <AddLinkToPill
                            buttonName="+ Add Secondary Advisor"
                            linkPathname="/my-account/edit"
                            styling="mt3"
                          />
                        </Col>
                      </Row>
                    </Col>
                  </>
                )
              )}
            </Row>
          </BlurContainer>
          {/******************************* DESIGNATED *************************************/}
          <SectionDivider />
          <BlurContainer ref={ref}>
            <JustifyBetweenAccessLevel>
              <AlignItemsCenter>
                <SectionLastHeading className="mb0">                 
                <ContentMessage type={[Types.SUB_HEADING_LEGACY_OPTIONS]} page="My Account" property="field_type_2_title" defaultMessage="Interested Party Details" />
                </SectionLastHeading>
              </AlignItemsCenter>
              <KnowAccessLevel />
            </JustifyBetweenAccessLevel>
            <WebView accData={accData.designatedParties} addBtn={false} />
          </BlurContainer>
          {/****************************** SUCCESSION **************************************/}
          <SectionDivider />
          <BlurContainer ref={ref}>
            <AlignItemsCenter className="mb-40">
              <SectionLastHeading className="mb0">
              <ContentMessage type={[Types.SUB_HEADING_LEGACY_OPTIONS]} page="My Account" property="field_type_3_title" defaultMessage="My Succession Plan" />
              </SectionLastHeading>
            </AlignItemsCenter>
            <SuccessionComponent data={accData.legacy} />
          </BlurContainer>
          {/****************************** AUTHORIZATION **************************************/}
          <SectionDivider />
          <SectionLastHeading className="mb3">
          <ContentMessage type={[Types.SUB_HEADING_LEGACY_OPTIONS]} page="My Account" property="field_type_5_title" defaultMessage="Authorization" />
          </SectionLastHeading>
          <DataHeading className="mb2">
            <ContentMessage type={[Types.SUB_HEADING_LEGACY_OPTIONS]} html={true} page="My Account" property="field_type_5_description" defaultMessage={this.props.getAutherizationDefaultContent()}/>
          </DataHeading>            
          <Row className="mt3">
            <Col lg={10} md={10} xs={24}>
              <ItemData>
              <ContentMessage type={[Types.SUB_HEADING_LEGACY_OPTIONS]} page="My Account" property="field_type_6_title" defaultMessage="Standing letter(s) of authorization on file"/>
              </ItemData>
                {vanguardAccts.length > 0 ? (
                  vanguardAccts.map((item, index) => (
                    <DataHeading key={index} >{item.accountNumber}</DataHeading>
                  ))
                ) : (
                  <DataHeading>None on file</DataHeading>
                )}
            </Col>
          </Row>
        </FixedWidth>
      </>
    );
  }
}

export default MyAccount;